<template>
  <div class="chat-container w-100 position-relative bg-white hide-scroll" >
    <top-navbar :title="$t('general.order-history')" :url="'/'+getMerchant().code+'/cart'" />
    <div class="d-block mt-5" v-if="is_load">
      <loader />
    </div>
    <div v-else class="pb-3">
      <div class="container pt-10" v-if="ticket_list.length > 0">
        <div class="w-100 d-table">
          <p class="body-2-4 pl-1 color-black float-left">{{$t('general.your-order-list')}}</p>
          <p class="body-3-3-1 mt-1 float-right pr-1 text-green">{{$t('general.tap-to-see-ticket-detail')}}</p>
        </div>
        <div class="mb-4" v-for="ticket in ticket_list" @click="goDetail(ticket.tx_order_id)">
          <div class="bg-white rounded-10 box-shadow-bold px-3 pt-2 pb-3 border" 
          :class="{
            'border-dark': printBorder(ifBeforeToday(ticket.visit_date,'YYYY-MM-DD'),ticket.status) == 'expired',
            'border-green': printBorder(ifBeforeToday(ticket.visit_date,'YYYY-MM-DD'),ticket.status) == 'COMPLETE',
            'border-danger': printBorder(ifBeforeToday(ticket.visit_date,'YYYY-MM-DD'),ticket.status) == 'CANCELLED',
            'border-info': printBorder(ifBeforeToday(ticket.visit_date,'YYYY-MM-DD'),ticket.status) == 'WAITING_PAYMENT_CONFIRMATION',
          }">
            <div class="d-table w-100 border-bottom pb-2">
              <div class="d-table float-left">
                <p class="mb-0 d-inline-block align-middle body-3-1">{{toLocalDate(ticket.transaction_date)}}</p>
                <p class="mb-0 d-inline-block align-middle body-3-3-3 mx-1">|</p>
                <p class="mb-0 d-inline-block align-middle body-3-3-2 text-green" v-if="ticket.status == 'COMPLETE'">{{$t('general.success')}}</p>
                <p class="mb-0 d-inline-block align-middle body-3-3-2 text-danger" v-else-if="ticket.status == 'CANCELLED'">{{$t('general.cancelled')}}</p>
                <p class="mb-0 d-inline-block align-middle body-3-3-2 text-info" v-else-if="ticket.status == 'WAITING_PAYMENT_CONFIRMATION'">{{$t('general.pending')}}</p>
              </div>
              <div class="d-table float-right">
                <img src="../../assets/img/icon/tickets.png" class="d-inline-block align-middle mr-1" width="15">
                <p class="d-inline-block align-middle mb-0 body-3-3-2">{{ticket.ticket_code}}</p>
              </div>
            </div>
            <div class="bg-white rounded-bottom-10">
              <div class="row slim-grid-row mt-2">
                <div class="col-3">
                  <div class="w-100 pt-1" style="height: 70px;">
                    <img :src="ticket.merchant.image_url" :class="{'bg-grey-overlay': ifBeforeToday(ticket.visit_date,'YYYY-MM-DD')}" class="radius-1 img-fit">
                  </div>
                </div>
                <div class="col-9">
                  <p class="mb-0 body-2-4" style="color: #414955">{{ticket.merchant.name}} {{$t('general.ticket')}}</p>
                  <p class="mb-0 body-3-3 text-truncate text-light-bold">
                    {{ticket.ticket_details.length}} {{$t('general.ticket')}}
                  </p>
                  <p class="mb-0 body-3-3 text-light-bold">{{$t('merchant.visit-date')}} : {{formatDate(ticket.visit_date)}}</p>
                  <p class="mb-0 body-2-4 text-orange">{{formatCurrency(ticket.total_payment)}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <infinite-loading v-if="last_page > 1" :forceUseInfiniteWrapper="true" spinner="spiral" @infinite="loadMore">
          <div slot="no-more"> </div>
          <div slot="no-results"> </div>
        </infinite-loading>
      </div>
      <div class="container text-center mt-8" v-else>
        <img src="../../assets/img/icon/404.png" width="310">
        <p class="pt-3 heading-4 text-22 mb-2 px-4 w-75 mx-auto">There is no order history</p>
        <p class="body-2 mb-4 px-4 mx-auto">Order ticket to see your order history.</p>
        <button class="border-green rounded py-2 px-4 bg-green" @click="goTicketList()">
          <p class="mb-0 pl-1 d-inline-block body-2 text-white" style="vertical-align: text-top;">Order Now</p>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {get} from '@/services/index.js';
  import {formatCurrency,formatDate} from '@/utils/index.js'
  import {mapGetters} from 'vuex';
  import moment from 'moment'
  export default {
    data() {
      return {
          ticket_list:[],
          page: 1,
          last_page: 1,
          is_load: false
      }
    },
    mounted(){
      this.loadOrderList()
    },
    methods:{
      ...mapGetters(['getMerchant']),
      toLocalDate(date){
        let testDateUtc = moment.utc(date);
        // let localDate = moment(date).local();
        return formatDate(testDateUtc);
      },
      formatDate(date){
        return formatDate(date);
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      loadOrderList(){
        this.is_load = true
        get("CORE","tx-ticket-details",{
          page: 1,
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          for(let i = 0; i < res.data.length; i++){

          }
          this.ticket_list = res.data
          this.page = res.current_page
          this.last_page = res.last_page
          this.is_load = false
        })
      },
      loadMore($state){
        if ((this.page+1) > this.last_page) {
          $state.complete();
        }else{
          get("CORE","tx-ticket-details",{
            page: this.page+1,
            merchant_id: this.getMerchant().id
          }).then(response=>{
            let res = response.data
            for(let i = 0; i < res.data.length; i++){
              this.ticket_list.push(res.data[i])
            }
            this.page = res.current_page
            this.last_page = res.last_page
            $state.loaded();
          })
        }
      },
      goDetail(id){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/ticket/order-history/'+id
        })
      },
      goTicketList(){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/list'
        })
      },
      ifBeforeToday(date,format=null){
        let today = new Date()
        if(format == null){
          if(moment(date).isSame(today)){
            return false
          }else if (moment(date).isSameOrBefore(today)) {
            return true
          }
        }else{
          if(date == moment(today).format(format)){
            return false
          }else if (moment(date,format).isSameOrBefore(today)) {
            return true
          }
        }
        return false
      },
      printBorder(date,status){
        if(date){
          return 'expired'
        }else{
          return status
        }
      }
    }
  }

</script>
<style scoped>
  .border-green{
    border-color: #79A33A !important;
  }
  .rounded-top-10 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .rounded-bottom-10{
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px; 
  }

  .bg-smoth-light {
    background-color: #FAFAFC;
  }

  .hide-scroll::-webkit-scrollbar {
    display: none;
  }

  .hide-scroll {
      -ms-overflow-style: none;
  }

  .plus-min-set{
    margin-top: -15px;
  }

  .plus-min-set input {
    margin-top: 10px;
  }

  .break{
    height: 15px
  }

  .img-width{
    width: 125px;
    height: 75px;
    object-fit: cover;
  }

  .bg-overlay{
    filter: grayscale(80%);
  }

  @media only screen and (max-width: 321px){
    .counter{
      width: 25px !important;
    }
  }

  @media only screen and (min-width: 600px){
    .counter{
      text-align: right !important;
    }
  }
  .bg-grey-overlay{
    filter: grayscale(80%);
  }
</style>


// WEBPACK FOOTER //
// src/pages/ticket/TicketOrderHistory.vue